export default __webpack_public_path__ + "static/media/icon-arrow-left.b211461c.svg";